<template>
  <div>
    <template v-if="bdictionary && bdictionary.length != 0">
      <b-field
        :label="$translate('orderType') | capitalize"
        :type="{ 'is-danger': errors.has('orderType') }"
        :message="errors.first('orderType')"
        horizontal
      >
        <b-select
          v-model="order.orderType"
          v-validate="'required'"
          :disabled="disabledbool"
          name="orderType"
          :placeholder="$translate('placeholder_type')"
          @input="
            order.orderTypeMain = null
            order.orderTypeVariant = null
            order.orderTypeSubVariant = null
            updateParent()
          "
        >
          <option v-for="optio in bdictionary" :key="optio.key" :value="optio.key">
            {{ $translate(optio.key) | capitalize }}
          </option>
        </b-select>
      </b-field>
    </template>
    <template
      v-if="
        bdictionary &&
          bdictionary.length != 0 &&
          bdictionary.find(temp => temp.key === order.orderType) != undefined &&
          bdictionary.find(temp => temp.key === order.orderType).variant
      "
    >
      <b-field
        v-if="bdictionary.find(temp => temp.key === order.orderType).variant"
        :label="$translate('orderTypeMain') | capitalize"
        :type="{ 'is-danger': errors.has('orderTypeMain') }"
        :message="errors.first('orderTypeMain')"
        horizontal
      >
        <b-select
          v-model="order.orderTypeMain"
          v-validate="'required'"
          :disabled="disabledbool"
          name="orderTypeMain"
          :placeholder="$translate('placeholder_type')"
          @input="
            order.orderTypeVariant = null
            order.orderTypeSubVariant = null
            updateParent()
          "
        >
          <option
            v-for="variant in bdictionary.find(temp => temp.key === order.orderType).variant"
            :key="variant.key"
            :value="variant.key"
          >
            {{ $translate(variant.key) }}
          </option>
        </b-select>
      </b-field>
    </template>

    <template
      v-if="
        bdictionary &&
          bdictionary.length != 0 &&
          bdictionary.find(temp => temp.key === order.orderType) != undefined &&
          bdictionary.find(temp => temp.key === order.orderType).variant &&
          bdictionary
            .find(temp => temp.key === order.orderType)
            .variant.find(temp => temp.key === order.orderTypeMain) != undefined
      "
    >
      <b-field
        v-if="
          bdictionary.find(temp => temp.key === order.orderType).variant.find(temp => temp.key === order.orderTypeMain)
            .variant
        "
        :label="$translate('orderTypeVariant') | capitalize"
        :type="{ 'is-danger': errors.has('orderTypeVariant') }"
        :message="errors.first('orderTypeVariant')"
        class="correction-error-field-body"
        horizontal
        expanded
      >
        <b-select
          v-model="order.orderTypeVariant"
          v-validate="'required'"
          :disabled="disabledbool"
          name="orderTypeVariant"
          :placeholder="$translate('placeholder_type')"
          @input="
            order.orderTypeSubVariant = null
            updateParent()
            if (
              (order.orderTypeVariant == 'formplusplant' &&
                order.deliverySelected &&
                (order.deliverySelected == 'testshoes' || order.deliverySelected == 'onlyforme')) ||
              (order.orderTypeVariant == 'form' &&
                order.deliverySelected &&
                (order.deliverySelected == 'testshoes' || order.deliverySelected == 'onlyforme'))
            ) {
              order.deliverySelected = null
              order.deliverySelectedSub = null
              updateParent()
            }
            /*if (
              order.orderTypeMain == 'measurements' &&
              order.orderTypeVariant == 'card2'
            ) {
              console.log(
                'DEVE IMPORRE UN MATERIALE, DEVO SPOSTA UN Pò DE ROBBA'
              );
            }*/
          "
        >
          <option
            v-for="subvariant in bdictionary
              .find(temp => temp.key === order.orderType)
              .variant.find(temp => temp.key === order.orderTypeMain).variant"
            :key="subvariant.key"
            :value="subvariant.key"
          >
            {{ $translate(subvariant.key) }}
          </option>
        </b-select>

        <template
          v-if="
            bdictionary &&
              bdictionary.length != 0 &&
              bdictionary.find(temp => temp.key === order.orderType) != undefined &&
              bdictionary.find(temp => temp.key === order.orderType).variant &&
              bdictionary
                .find(temp => temp.key === order.orderType)
                .variant.find(temp => temp.key === order.orderTypeMain) != undefined &&
              bdictionary
                .find(temp => temp.key === order.orderType)
                .variant.find(temp => temp.key === order.orderTypeMain)
                .variant.find(temp => temp.key === order.orderTypeVariant) != undefined
          "
        >
          <b-field
            v-if="
              bdictionary
                .find(temp => temp.key === order.orderType)
                .variant.find(temp => temp.key === order.orderTypeMain)
                .variant.find(temp => temp.key === order.orderTypeVariant).variant
            "
            :label="$translate('orderTypeSubVariant') | capitalize"
            :type="{ 'is-danger': errors.has('orderTypeSubVariant') }"
            :message="errors.first('orderTypeSubVariant')"
            horizontal
            expanded
          >
            <b-select
              v-model="order.orderTypeSubVariant"
              v-validate="'required'"
              :disabled="disabledbool"
              name="orderTypeSubVariant"
              :placeholder="$translate('placeholder_type')"
              @input="updateParent()"
            >
              <option
                v-for="subsubvariant in bdictionary
                  .find(temp => temp.key === order.orderType)
                  .variant.find(temp => temp.key === order.orderTypeMain)
                  .variant.find(temp => temp.key === order.orderTypeVariant).variant"
                :key="subsubvariant.key"
                :value="subsubvariant.key"
              >
                {{ $translate(subsubvariant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>
      </b-field>
    </template>
    <b-field
      v-if="
        order.orderTypeVariant == 'card2' ||
          (order.orderTypeVariant && order.orderTypeMain == 'last') ||
          (order.orderTypeVariant && order.orderTypeMain == 'mold') ||
          (order.orderTypeMain == 'digitalMeasurements' && order.orderTypeVariant == 'formproj')
      "
      :label="$translate('formcode') | capitalize"
      :type="{ 'is-danger': errors.has('formcode') }"
      :message="errors.first('formcode')"
      horizontal
    >
      <b-input v-model="order.formcode" name="formcode" :disabled="disabledbool" />
    </b-field>

    <hr class="green" />

    <template v-if="ddictionary && ddictionary.length != 0">
      <b-field
        :label="$translate('deliverySelected') | capitalize"
        :type="{ 'is-danger': errors.has('deliverySelected') }"
        :message="errors.first('deliverySelected')"
        horizontal
        class="correction-error-field-body"
      >
        <b-select
          v-model="order.deliverySelected"
          v-validate="'required'"
          :disabled="disabledbool"
          name="deliverySelected"
          :placeholder="$translate('placeholder_type')"
          @input="
            order.deliverySelectedSub = null
            updateParent()
          "
        >
          <template v-for="optio in ddictionary">
            <option
              v-if="
                !(
                  (order.orderTypeVariant == 'formplusplant' &&
                    (optio.key == 'testshoes' || optio.key == 'onlyforme')) ||
                  (order.orderTypeVariant == 'form' && (optio.key == 'testshoes' || optio.key == 'onlyforme'))
                )
              "
              :key="optio.key"
              :value="optio.key"
            >
              {{ $translate(optio.key) }}
            </option>
          </template>
        </b-select>
        <template
          v-if="
            ddictionary &&
              ddictionary.length != 0 &&
              ddictionary.find(temp => temp.key === order.deliverySelected) != undefined
          "
        >
          <b-field
            v-if="ddictionary.find(temp => temp.key === order.deliverySelected).variant"
            :label="$translate('deliverySelectedSub') | capitalize"
            :type="{ 'is-danger': errors.has('deliverySelectedSub') }"
            :message="errors.first('deliverySelectedSub')"
            horizontal
          >
            <b-select
              v-model="order.deliverySelectedSub"
              v-validate="'required'"
              :disabled="disabledbool"
              name="deliverySelectedSub"
              :placeholder="$translate('placeholder_type')"
              @input="updateParent()"
            >
              <option
                v-for="variant in ddictionary.find(temp => temp.key === order.deliverySelected).variant"
                :key="variant.key"
                :value="variant.key"
              >
                {{ $translate(variant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>
      </b-field>
    </template>

    <hr class="green" />

    <b-field :label="$translate('pairSelected') | capitalize" horizontal>
      <b-select
        v-model="order.pair"
        v-validate="'required'"
        :disabled="disabledbool"
        name="pairSelected"
        @input="onPairChange"
      >
        <option :key="0" value="both">{{ $translate('pairBoth') }}</option>
        <option :key="1" value="right">{{ $translate('pairRight') }}</option>
        <option :key="2" value="left">{{ $translate('pairLeft') }}</option>
      </b-select>
    </b-field>

    <hr class="green" />

    <b-field v-if="!isSimplified" grouped>
      <b-field :label="$translate('last_in') | capitalize" horizontal expanded>
        <b-checkbox v-model="order.footmeasurements['last_in']" :disabled="disabledbool" />
      </b-field>
      <b-field :label="$translate('without_junction') | capitalize" horizontal expanded>
        <b-checkbox
          v-model="order.footmeasurements['without_junction']"
          :disabled="disabledbool"
          @input="changeWithoutJunction()"
        />
      </b-field>
    </b-field>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/highlowmeauserements'
import '../../../helpers/mixins/variables/formames'
import '../../../helpers/mixins/variables/fondo'
import '../../../helpers/mixins/variables/allacciaturames'

export default {
  name: 'OrderTypology',
  /*props: [
    "order",
    "bdictionary",
    "ddictionary",
    "bDictionaryName",
    "dDictionaryName",
    "disabledbool",
  ],*/
  props: {
    order: {
      type: Object,
      default: () => {
        return {}
      },
    },
    bdictionary: {
      type: Array,
      default: () => {
        return []
      },
    },
    ddictionary: {
      type: Array,
      default: () => {
        return []
      },
    },
    bDictionaryName: {
      type: String,
      default: '',
    },
    dDictionaryName: {
      type: String,
      default: '',
    },
    disabledbool: Boolean,
    isSimplified: Boolean,
  },
  inject: ['$validator'],
  data() {
    return {
      filteredDDictionary: this.updateParent(),
    }
  },
  methods: {
    onPairChange() {
      if (this.order.pair !== 'both') {
        this.$buefy.dialog.confirm({
          title: this.$translate('attention'),
          message: this.$translate('message_reset_measurements'),
          cancelText: this.$translate('undo_reset_measurements'),
          confirmText: this.$translate('confirm_reset_measurements'),
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert',
          onConfirm: () => this.enableOneSide(),
          onCancel: () => (this.order.pair = 'both'),
        })
      }
    },
    enableOneSide() {
      this.order.isDunaInsoleDisabledDx = this.order.pair === 'left'
      this.order.isDunaInsoleDisabledSx = this.order.pair === 'right'
      if (this.order.pair === 'left') {
        if (this.order.footmeasurements.c_pair !== 'sx_c_pair') this.order.footmeasurements.c_pair = 'not_spec'
        this.deleteMeasurementsRight()
        this.deleteProdDetailsRight()
      }
      if (this.order.pair === 'right') {
        this.deleteMeasurementsLeft()
        this.deleteProdDetailsLeft()
      }
    },
    deleteMeasurementsRight() {
      // misure del piede
      for (const m of this.$highlowmeasu) {
        this.order.footmeasurements[m.key + '_dx'] = null
      }
      this.order.footmeasurements.block_F_E_dx = null
      this.order.footmeasurements.block_P_S_dx = null
      // istruzioni specifiche sulla forma
      for (const m of this.$formames) {
        this.order.footmeasurements[m.key + 'foot_dx'] = null
        this.order.footmeasurements[m.key + 'plan_dx'] = null
      }
      this.order.footmeasurements.scari_retro_dx = null
      this.order.footmeasurements.scari_retro_dx_num = null
      this.order.footmeasurements.scari_meso_dx = null
      this.order.footmeasurements.scari_meso_dx_num = null
      // plantare realizzazione duna
      this.order.secondplantdx = false
      this.order.footmeasurements['thick_cen_heel_dx'] = null
      this.order.footmeasurements['thick_pla_dx'] = null
      this.order.footmeasurements['thick_poi_dx'] = null
      this.order.footmeasurements['pla_til_heel_dx'] = null
      this.order.footmeasurements['pla_til_poi_dx'] = null
      this.order.footmeasurements['height_col_med_dx'] = null
      this.order.footmeasurements['height_col_lat_dx'] = null
      this.order.footmeasurements['artificial_point_dx'] = 'n'
      this.order.footmeasurements['artificil_point_dx_optional'] = null
      this.order.footmeasurements['plantar_type_dx'] = 'Noone'
      this.order.footmeasurements['base_mat_dx'] = null
      this.order.footmeasurements['base_matvar_dx'] = null
      this.order.footmeasurements['surface_mat_dx'] = null
      this.order.footmeasurements['fin_dess_dx'] = null
      this.order.footmeasurements['pelotte_dx'] = null
      this.order.footmeasurements['base_mat_dx2'] = null
      this.order.footmeasurements['base_matvar_dx2'] = null
      this.order.footmeasurements['surface_mat_dx2'] = null
      this.order.footmeasurements['fin_dess_dx2'] = null
      this.order.footmeasurements['pelotte_dx2'] = null
      // plantare realizzazione propria
      this.order.footmeasurements['plant_dx'] = null
      this.order.footmeasurements['tacc_dx'] = null
      // scarpa
      this.order.footmeasurements.measure_dx = null
      for (const m of this.$allacciaturames) {
        this.order.footmeasurements[m.key + '_dx'] = null
      }
      for (const m of this.$fondo) {
        this.order.footmeasurements[m.key + '_dx'] = null
      }
      this.order.footmeasurements.crimp_heel_dx = null
    },
    deleteMeasurementsLeft() {
      // misure del piede
      for (const m of this.$highlowmeasu) {
        this.order.footmeasurements[m.key + '_sx'] = null
      }
      this.order.footmeasurements.block_F_E_sx = null
      this.order.footmeasurements.block_P_S_sx = null
      // istruzioni specifiche sulla forma
      for (const m of this.$formames) {
        this.order.footmeasurements[m.key + 'foot_sx'] = null
        this.order.footmeasurements[m.key + 'plan_sx'] = null
      }
      this.order.footmeasurements.scari_retro_sx = null
      this.order.footmeasurements.scari_retro_sx_num = null
      this.order.footmeasurements.scari_meso_sx = null
      this.order.footmeasurements.scari_meso_sx_num = null
      // plantare realizzazione duna
      this.order.secondplantsx = false
      this.order.footmeasurements['thick_cen_heel_sx'] = null
      this.order.footmeasurements['thick_pla_sx'] = null
      this.order.footmeasurements['thick_poi_sx'] = null
      this.order.footmeasurements['pla_til_heel_sx'] = null
      this.order.footmeasurements['pla_til_poi_sx'] = null
      this.order.footmeasurements['height_col_med_sx'] = null
      this.order.footmeasurements['height_col_lat_sx'] = null
      this.order.footmeasurements['artificial_point_sx'] = 'n'
      this.order.footmeasurements['artificil_point_sx_optional'] = null
      this.order.footmeasurements['plantar_type_sx'] = 'Noone'
      this.order.footmeasurements['base_mat_sx'] = null
      this.order.footmeasurements['base_matvar_sx'] = null
      this.order.footmeasurements['surface_mat_sx'] = null
      this.order.footmeasurements['fin_dess_sx'] = null
      this.order.footmeasurements['pelotte_sx'] = null
      this.order.footmeasurements['base_mat_sx2'] = null
      this.order.footmeasurements['base_matvar_sx2'] = null
      this.order.footmeasurements['surface_mat_sx2'] = null
      this.order.footmeasurements['fin_dess_sx2'] = null
      this.order.footmeasurements['pelotte_sx2'] = null
      // plantare realizzazione propria
      this.order.footmeasurements['plant_sx'] = null
      this.order.footmeasurements['tacc_sx'] = null
      // scarpa
      this.order.footmeasurements.measure_sx = null
      for (const m of this.$allacciaturames) {
        this.order.footmeasurements[m.key + '_sx'] = null
      }
      for (const m of this.$fondo) {
        this.order.footmeasurements[m.key + '_sx'] = null
      }
      this.order.footmeasurements.crimp_heel_sx = null
    },
    deleteProdDetailsRight() {
      // imbottiture
      this.order.masch_dx = null
      this.order.ling_dx = null
      this.order.mallmed_dx = null
      this.order.malllat_dx = null
      this.order.termtom_dx = null
      this.order.imb_gamb_dx = null
      // contrafforti
      this.order.typecontr_dx = null
      this.order.tipocontr_dx = null
      this.order.tipocontr_var_dx = null
      this.order.tiporinfcontr_dx = null
      this.order.matrinfcontr_dx = null
      this.order.matrinfcontr_var_dx = null
      // puntali
      this.order.tipopunt_dx = null
      this.order.tipopunt_mat_dx = null
      this.order.tipopunt_mat_var_dx = null
      // sottopiede
      this.order.tiposott_dx = null
      this.order.tiposott_var_dx = null
      this.order.tiporinfsott_dx = null
      // soletta di vantaggio
      this.order.footmeasurements.thick_plant_dx = null
      this.order.footmeasurements.thick_tacc_dx = null
    },
    deleteProdDetailsLeft() {
      // imbottiture
      this.order.masch_sx = null
      this.order.ling_sx = null
      this.order.mallmed_sx = null
      this.order.malllat_sx = null
      this.order.termtom_sx = null
      this.order.imb_gamb_sx = null
      // contrafforti
      this.order.typecontr_sx = null
      this.order.tipocontr_sx = null
      this.order.tipocontr_var_sx = null
      this.order.tiporinfcontr_sx = null
      this.order.matrinfcontr_sx = null
      this.order.matrinfcontr_var_sx = null
      // puntali
      this.order.tipopunt_sx = null
      this.order.tipopunt_mat_sx = null
      this.order.tipopunt_mat_var_sx = null
      // sottopiede
      this.order.tiposott_sx = null
      this.order.tiposott_var_sx = null
      this.order.tiporinfsott_sx = null
      // soletta di vantaggio
      this.order.footmeasurements.thick_plant_sx = null
      this.order.footmeasurements.thick_tacc_sx = null
    },
    updateParent() {
      if (this.bDictionaryName == 'B1' && this.order.orderTypeMain == 'last') {
        this.filteredDDictionary = this.ddictionary.filter(el => {
          return el.key == 'devshoeended' || el.key == 'onlytom'
        })
      } else {
        this.filteredDDictionary = this.ddictionary
      }
      this.$forceUpdate()
      this.$emit('updateParent')
    },
    changeWithoutJunction() {
      if (this.order.footmeasurements['without_junction']) {
        this.order.footmeasurements['last_in'] = this.order.footmeasurements['without_junction']
        this.$forceUpdate()
      }
    },
  },
}
</script>
